import HttpRequest from '../../lib/HttpRequest'

const api = new HttpRequest('investments')
const actions = {
  available: ({ commit }, id) => api.post('available', { id })
    .then(({ data }) => commit('investments/available', data)),

  async invest ({ commit }, payload) {
    commit('investments/errorOnInvest', undefined)
    commit('investments/isInvestPending', true)

    await api.post('invest', payload)
      .then(({ data }) => commit('investments/invest', data))
      .catch(({ response }) => commit('investments/errorOnInvest', response.data))

    commit('investments/isInvestPending', false)
  }
}

export default actions
